import { Component, Vue, Prop } from "vue-property-decorator";
import template from "./rim-repair-loading.template.vue";

@Component({
  mixins: [template]
})
export default class RimRepairLoadingComponent extends Vue {
  @Prop({ default: false }) state!: boolean;
}
